import {Mask} from './Mask';
import {transitionByClass} from '../Library/Animation';

const currentSidebar = () => document.querySelector('nav.sidebar');

const mask = Mask({
    excludedCloseHandlers: ['nav.sidebar', '#open-sidebar'],
    onClose: () => {
        const sidebar = currentSidebar();

        sidebar.classList.remove('active');

        transitionByClass(sidebar, 'animate');
    },
    className: 'sidebar-mask',
    mobileOnly: true,
});

export const Sidebar = {
    open: () => {
        const sidebar = currentSidebar();

        sidebar.classList.add('active');

        transitionByClass(sidebar, 'animate');

        mask.render();
    },
    close: () => {
        const sidebar = currentSidebar();

        sidebar.classList.remove('active');

        transitionByClass(sidebar, 'animate');

        mask.hide();
    },
    toggle: () => {
        if (currentSidebar().classList.contains('active')) {
            Sidebar.close();
        } else {
            Sidebar.open();
        }
    },
};

export const syncFoldersCollapseHandle = () => {
    const folders = document.getElementById('sidebar-folders');
    const handle  = document.querySelector('[data-collapse="#sidebar-folders"]');

    if (!folders || !handle) {
        return;
    }

    handle.classList.toggle('collapsed', folders.classList.contains('collapsed'));
};

const endSidebarTransition = () => {
    currentSidebar()?.classList.remove('sidebar-transitioning', 'menu-revealed');
};

window.matchMedia('(max-width: 576px)').addEventListener('change', endSidebarTransition);

let flyoutCloseTimer = null;
let openFlyout = null;

const closeFlyout = () => {
    clearTimeout(flyoutCloseTimer);

    openFlyout?.classList.remove('flyout-open');

    flyoutCloseTimer = null;
    openFlyout        = null;
};

const collapseSidebar = sidebar => {
    const collapsed = !sidebar.classList.contains('collapsed');
    const data = new FormData();

    data.set('sidebarCollapsed', collapsed ? 'true' : 'false');

    fetch(sidebar.dataset.collapseSidebarUrl, {
        method: 'post',
        body: data,
    });

    sidebar.classList.add('sidebar-transitioning');
    sidebar.classList.toggle('collapsed', collapsed);

    if (collapsed) {
        sidebar.classList.remove('menu-revealed');
    }
};

export const handleSidebarClick = event => {
    const sidebar = currentSidebar();

    if (!sidebar) {
        return false;
    }

    if (event.target.closest('#open-sidebar')) {
        event.preventDefault();

        Sidebar.toggle();

        return true;
    }

    if (event.target.closest('.collapse-sidebar')) {
        event.preventDefault();

        collapseSidebar(sidebar);

        return true;
    }

    const menuToggle = event.target.closest('[data-toggle-menu]');

    if (!menuToggle || !sidebar.contains(menuToggle)) {
        return false;
    }

    const data = new FormData();

    data.set('menuUrl', menuToggle.dataset.toggleMenu);

    fetch(sidebar.dataset.collapseMenuItemUrl, {
        method: 'post',
        body: data,
    });

    return false;
};

const flyoutFromTarget = target => {
    const item = target.closest('nav.sidebar .menu-collapsed > li');

    return item?.querySelector('.collapsed-flyout') ? item : null;
};

export const handleSidebarMouseOver = event => {
    const item = flyoutFromTarget(event.target);

    if (!item || item.contains(event.relatedTarget)) {
        return;
    }

    closeFlyout();

    item.classList.add('flyout-open');
    openFlyout = item;
};

export const handleSidebarMouseOut = event => {
    const item = flyoutFromTarget(event.target);

    if (!item || item.contains(event.relatedTarget)) {
        return;
    }

    clearTimeout(flyoutCloseTimer);

    flyoutCloseTimer = setTimeout(() => {
        if (openFlyout === item) {
            closeFlyout();
        }
    }, 150);
};

export const handleSidebarTransitionEnd = event => {
    const sidebar = currentSidebar();

    if (event.target === sidebar && event.propertyName === 'width') {
        if (sidebar.classList.contains('collapsed')) {
            endSidebarTransition();
        } else {
            sidebar.classList.add('menu-revealed');
        }

        return;
    }

    if (event.propertyName === 'opacity' && event.target.matches('nav.sidebar > .menu') && sidebar.classList.contains('menu-revealed')) {
        endSidebarTransition();
    }
};

export const resetSidebar = () => {
    closeFlyout();

    const sidebar = currentSidebar();

    sidebar?.classList.remove('active', 'sidebar-transitioning', 'menu-revealed');
    sidebar?.querySelectorAll('.flyout-open').forEach(item => item.classList.remove('flyout-open'));

    mask.reset();
};
